export default __webpack_public_path__ + "img/sec-4-fg.png";